import React from 'react';
import { motion } from 'framer-motion';
import { User, UserX, UserCheck } from 'lucide-react';
export function WhoIsThisFor() {
  const audiences = [{
    icon: <User size={32} className="text-link-blue" data-id="element-258" />,
    title: 'Principiantes',
    text: 'Para quienes sienten que el marketing digital es un laberinto y necesitan una ruta clara para empezar.'
  }, {
    icon: <UserX size={32} className="text-link-blue" data-id="element-259" />,
    title: 'Personas bloqueadas',
    text: 'Para quienes ya han visto cursos o contenido, pero no saben cómo convertirlo en acción real.'
  }, {
    icon: <UserCheck size={32} className="text-link-blue" data-id="element-260" />,
    title: 'Emprendedores y creadores',
    text: 'Para quienes quieren vender mejor, lanzar campañas, automatizar procesos y usar IA para crecer.'
  }];
  return <section className="py-12 lg:py-16 bg-white" data-id="element-261">
      <div className="container mx-auto px-4 md:px-6" data-id="element-262">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-6" data-id="element-264">
            ¿Para quién es Link Academy?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-265">
          {audiences.map((audience, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-3xl border border-gray-100 hover:bg-link-light/50 transition-colors" data-id="element-266">
              <div className="w-16 h-16 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-6" data-id="element-267">
                {audience.icon}
              </div>
              <h3 className="text-xl font-bold text-link-dark mb-3" data-id="element-268">
                {audience.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-269">{audience.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}